'use client';

import CompareFilters from "../components/CompareFilters";

export default CompareFilters;
